import { render, staticRenderFns } from "./drawer-main-control-box-current.vue?vue&type=template&id=3a087c96&"
import script from "./drawer-main-control-box-current.vue?vue&type=script&lang=js&"
export * from "./drawer-main-control-box-current.vue?vue&type=script&lang=js&"
import style0 from "./drawer-main-control-box-current.vue?vue&type=style&index=0&id=3a087c96&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports